import TableTrueValueComponent from './TableTrueValueComponent';
import { useStyles } from './TableTrueValueStyles';

export default TableTrueValueComponent;

export { useStyles };
